import {checkSectionVisibility} from '../Common/checkSectionVisibility';

export function populateTeam(jsonData){

    teamData = jsonData;

    var teamHeadingText = jsonData.team.section_heading.value;

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#teamHeadingText").html(teamHeadingText);        
    }
    else{    
        checkSectionVisibility(jsonData.team.visibility, $(".team"));                        
        $("input#teamHeadingText").val(teamHeadingText);
    }
    
    function getMembers() {
        var member = $('.team__member.prototype.hidden').clone().removeClass('prototype hidden');
        member.addClass("member")
        return {
            element: member,
            name: member.find('.team__member__name').find(".member_name"),
            designation: member.find('.team__member__name').find(".member_designation"),
            aboutContainer: member.find('.team__member__about'),
            about: member.find('.team__member__about').find(".member_about"),
            image: member.find('.team__member__image').find(".member_image"),
            youtube: member.find(".team__member__image").find("#youtubeLink"),
            socialContainer: member.find(".team__member__social"),
            twitter: member.find(".team__member__social").find("#twitterLink"),
            facebook: member.find(".team__member__social").find("#facebookLink"),
            linkedin: member.find(".team__member__social").find("#linkedinLink")
        }
    }

    var count = 0;
    function populateData(jsonData){
        $.each(jsonData.team.data.members, function(index, Item) {
            if(count<jsonData.team.data.maximum){
                var newMember = getMembers();
                if(!$(document).find(".preview").hasClass("hidden")){
                    if(count>=3){
                        newMember.element.addClass("moreTeam hidden");
                    }
                    
                    newMember.name.html(Item.name.value);
                    newMember.designation.html(Item.designation.value); 
                    newMember.youtube.attr("href", Item.youtube.link);
                    // newMember.youtube.addClass("playVideo");
                    newMember.twitter.attr("href", Item.twitter.link);
                    newMember.facebook.attr("href", Item.facebook.link);
                    newMember.linkedin.attr("href", Item.linkedIn.link);
                    

                    if(!Item.about.value || Item.about.value == " "){                        
                        newMember.about.parent().remove();   
                        
                        if($(window).width()< 768){
                            newMember.socialContainer.css("top", "60% ");
                        }
                    }else{
                        newMember.about.html(Item.about.value.replace(/\n/g, "<br>"));
                    }
                    
                    if(Item.about.value.length > 138){
                        newMember.aboutContainer.css("position", "relative");
                        newMember.aboutContainer.find(".readTeam").removeClass("hidden");
                    }
                    
                    if(!Item.linkedIn.link){
                        newMember.linkedin.remove()
                    }
                    
                    if(!Item.facebook.link){
                        newMember.facebook.remove()
                    }
                    if(!Item.twitter.link){
                        newMember.twitter.remove()
                    }

                    // if($(window).width < 768){
                        if(!Item.linkedIn.link && !Item.facebook.link && !Item.twitter.link){
                            newMember.socialContainer.remove()
                        }
                    // }
                    

                    if(!Item.youtube.link){
                        newMember.youtube.remove()
                    }                    
                }
                else{                    
                    newMember.name.val(Item.name.value);
                    newMember.designation.val(Item.designation.value);
                    newMember.about.html(Item.about.value);
                    if(count>=3){
                        newMember.element.find(".removeMember").removeClass("hidden");
                    }
                }
                newMember.image.attr('src', Item.image.path);  
                newMember.image.attr('data-src', Item.image.path); 

                if(Item.image.path.indexOf('_cropped')> -1){
                    newMember.image.attr('data-original-src',Item.image.path.split('_cropped')[0] + '.jpg');
                }
                else{
                    newMember.image.attr('data-original-src',Item.image.path);  
                }

                newMember.youtube.attr("data", Item.youtube.link);
                newMember.twitter.attr("data", Item.twitter.link);
                newMember.facebook.attr("data", Item.facebook.link);
                newMember.linkedin.attr("data", Item.linkedIn.link);

                if(Item.linkedIn.link){
                    newMember.linkedin.find("i").removeClass("unfilled");  
                }
                
                if(Item.facebook.link){
                    newMember.facebook.find("i").removeClass("unfilled");  
                }

                if(Item.twitter.link){
                    newMember.twitter.find("i").removeClass("unfilled");  
                }

                if(count>=3 && $(window).width() >= 768){
                    newMember.element.css("margin-top", "50px");
                }
                newMember.element.css("display", "inline-block");
                $('.team__container').append(newMember.element);

                count++;
            }
        });

        $(".readTeam").click(function(e) {            
            e.preventDefault();
            $(this).closest('.team__member').find('.member_about').toggleClass('more');
            if($(this).closest('.team__member').find('.member_about').hasClass("more")) {
                $(this).text("Read Less");
                if($(this).hasClass("readMoreFirst")) {
                    $(this).addClass("readLessFirst")
                }
            }
            else {
                $(this).text("Read More");
                $(this).removeClass("readLessFirst")
            }
        })
    }

    function addDynamicTeamMember(){
        var newMember = getMembers();
        newMember.image.attr("src", pageUrl+"/static/images/team_1.png");
        newMember.youtube.find("img").attr("src", pageUrl+"/static/images/play.svg")
        newMember.element.css("margin-top", "50px");
        newMember.element.css("display", "inline-block");
        newMember.element.find(".removeMember").removeClass("hidden");
        $('.team__container').append(newMember.element);
        newMember.element.css("background-color", "#cbe4ff");
        window.setTimeout(function(){
            newMember.element.css("background-color", "initial"); 
        }, 1000);
    }

    $(".addTeamMember").on('click', function(){        
        if(count<jsonData.team.data.maximum){
            addDynamicTeamMember();
            count++            
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });   

    $(".team__container").on('click', ".removeMember" ,function(){                  
        $(this).parent().remove();
        count--;        
    });

    populateData(jsonData);

    function showMoreTeam(){     
        var showMoreContainer = $(".show-more-container.teamMore");
        var showMoreButton = showMoreContainer.find("button");
        if(count>3){
            showMoreContainer.removeClass("hidden");
            showMoreButton.html("See More");
            showMoreButton.append("<i class='icon-down_arrow'></i>")
        }

        showMoreButton.on('click', function(){
            if($(".moreTeam").hasClass("hidden")){
                $(".moreTeam").removeClass("hidden");
                showMoreButton.html("See Less");
                showMoreButton.append("<i class='icon-top_arrow'></i>");
            }
            else{
                $(".moreTeam").addClass("hidden");
                showMoreButton.html("See More");
                showMoreButton.append("<i class='icon-down_arrow'></i>");
            }
        });
    }

    if(!$(document).find(".preview").hasClass("hidden")){
        showMoreTeam();
    }
}